// Minimal JSON-POST helper. Every inrange-agents route is a POST
// that takes a JSON body and returns a JSON body, so a single helper
// covers the surface. ``authToken`` is REQUIRED on every call -
// every inrange-agents env (dev, QA, prod) enforces Kinde auth, so
// there is no unauthenticated entry point. Callers should go
// through ``useAgentsHttp`` which resolves the token via
// ``getAuthTokenBlocking`` and forwards here.

export interface PostJsonError extends Error {
  status?: number;
  bodyText?: string;
}

export async function postJson<TResp>(
  baseUrl: string,
  path: string,
  body: unknown,
  authToken: string,
): Promise<TResp> {
  const url = `${baseUrl.replace(/\/$/, "")}${path}`;
  const resp = await fetch(url, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify(body ?? {}),
  });
  if (!resp.ok) {
    const text = await resp.text();
    const err = new Error(
      `${resp.status} ${resp.statusText}: ${text}`,
    ) as PostJsonError;
    err.status = resp.status;
    err.bodyText = text;
    throw err;
  }
  return (await resp.json()) as TResp;
}
